import { Injectable } from '@angular/core';
import { CartActions } from '@cart/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MultiCartEffects {
  setTempCart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActions.SET_TEMP_CART),
      map((action: CartActions.SetTempCart) => {
        return new CartActions.RemoveCart({ cartId: action.payload.tempCartId });
      }),
    ),
  );

  processesIncrement$: Observable<CartActions.CartProcessesIncrement> = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActions.CART_ADD_VOUCHER),
      map((action: CartActions.CartAddVoucher) => action.payload),
      map((payload) => new CartActions.CartProcessesIncrement(payload.cartId)),
    ),
  );

  constructor(private actions$: Actions) {}
}
